import React, { useEffect, useState } from 'react';
import { Table, Tag, message } from 'antd';
import { fetchAudit } from '../../api';

const AuditTrailTab = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 50, total: 0 });

  const load = async (page = 1) => {
    setLoading(true);
    try {
      const res = await fetchAudit({ page, limit: pagination.pageSize });
      setData(res.data || []);
      setPagination((p) => ({ ...p, current: page, total: res.pagination?.total || 0 }));
    } catch { message.error('Failed to load audit log'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(1); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const columns = [
    { title: 'When', dataIndex: 'createdAt', render: (d) => new Date(d).toLocaleString() },
    { title: 'Action', dataIndex: 'action', render: (a) => <Tag color="blue">{a}</Tag> },
    { title: 'Target', dataIndex: 'targetModel', render: (m, r) => `${m}${r.targetRef ? ` · ${r.targetRef}` : ''}` },
    { title: 'By', dataIndex: 'performedBy', render: (u) => (u ? `${u.name} (${u.employeeCode || ''})` : '—') },
    { title: 'Approved By', dataIndex: 'approvedBy', render: (u) => (u ? `${u.name}` : '—') },
  ];

  return (
    <Table rowKey="_id" columns={columns} dataSource={data} loading={loading} size="small"
      pagination={pagination} onChange={(p) => load(p.current)} />
  );
};

export default AuditTrailTab;
